import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["value", "disabled", "type"]
const _hoisted_2 = {
  key: 0,
  class: "lds-ring"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _mergeProps({ value: _ctx.value }, _ctx.$attrs, {
    disabled: _ctx.disabled || _ctx.isLoading,
    class: [_ctx.priority, { hasIcon: _ctx.hasIcon }],
    type: _ctx.type
  }), [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", null, null, -1),
          _createElementVNode("div", null, null, -1),
          _createElementVNode("div", null, null, -1),
          _createElementVNode("div", null, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      style: _normalizeStyle({ opacity: _ctx.isLoading? 0: 1 })
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _createTextVNode(" " + _toDisplayString(_ctx.value), 1)
    ], 4)
  ], 16, _hoisted_1))
}